import { AnimatePresence } from 'framer-motion'
import { Backdrop, ModalContainer, ModalContent } from './styled-components'
import ModalHeader from './components/modal-header'
import ModalActions from './components/modal-actions'
import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import { modalSizeOptions } from './constants'
import { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'

const ModalsComponent = ({
  isOpen,
  onClose = () => {},
  showCloseButton = true,
  title,
  size = modalSizeOptions.MEDIUM,
  children,
  rightButtons,
  leftButtons,
  textLinkButton,
  autoHeight = false,
  ...props
}) => {
  const contentRef = useRef(null)
  const [modalWidth, setModalWidth] = useState()
  const showActionBar =
    !isEmpty(rightButtons) || !isEmpty(leftButtons) || !isEmpty(textLinkButton)

  useEffect(() => {
    if (contentRef.current && isOpen) {
      const updateWidth = () => {
        const width = contentRef.current.getBoundingClientRect().width
        setModalWidth(width)
      }

      updateWidth()
    }
  }, [isOpen])

  return createPortal(
    <AnimatePresence>
      {isOpen && (
        <Backdrop
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <ModalContainer
            size={size}
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            transition={{ duration: 0.2 }}
            onClick={(e) => e.stopPropagation()}
            {...props}
          >
            <ModalHeader
              title={title}
              onClose={onClose}
              showCloseButton={showCloseButton}
            />
            <ModalContent
              ref={contentRef}
              modalWidth={autoHeight ? null : modalWidth}
            >
              {children}
            </ModalContent>
            {showActionBar && (
              <ModalActions
                rightButtons={rightButtons}
                leftButtons={leftButtons}
                textLinkButton={textLinkButton}
              />
            )}
          </ModalContainer>
        </Backdrop>
      )}
    </AnimatePresence>,
    document.body
  )
}

const ButtonDataPropType = PropTypes.shape({
  title: PropTypes.string,
  action: PropTypes.func,
  variant: PropTypes.string
})

ModalsComponent.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  showCloseButton: PropTypes.bool,
  title: PropTypes.string.isRequired,
  size: PropTypes.arrayOf(Object.values(modalSizeOptions)),

  rightButtons: PropTypes.arrayOf(ButtonDataPropType),
  leftButtons: PropTypes.arrayOf(ButtonDataPropType),
  textLinkButton: PropTypes.shape({
    title: PropTypes.string,
    to: PropTypes.string,
    emphasis: PropTypes.string
  })
}

export default ModalsComponent
